import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { UsersService } from 'src/app/super-management/user/users.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataSharingService } from 'src/app/main-section/data-shering-service/data-sharing.service';

import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { getPhCollectionServicePrice } from 'src/app/main-section/ph-printing-table/ph-service-data';

@Component({
  selector: 'app-property-explain',
  templateUrl: './property-explain.component.html',
  styleUrls: ['./property-explain.component.css'],
})

export class PropertyExplainComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;
  isLoadingUpdates = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  property: string = '';
  printingService: string = '';
  realBranch: any = {};
  isPaperChoosen: boolean = false;
  isPh: boolean = false;
  isCollectOptions: boolean = false;

  inputBins: any[];
  printServicePapers: any[];

  selectedCollectOption: string = '';
  productName: string = '';
  product: any;
  materialData: { availableMaterials: any[], selected3DMaterial: string, productName: string };
  availableMaterials: any[] = [];

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataSharingService: DataSharingService,
    public dialogRef: MatDialogRef<PropertyExplainComponent>,
    private translateService: TranslateService
  ) {
    this.property = data.property;
    this.printingService = data.printingService;
    this.realBranch = data.realBranch;
    this.isPaperChoosen = data.isPaperChoosen ? data.isPaperChoosen : false;
    this.isPh = data.isPh ? data.isPh : false;
    this.isCollectOptions = data.isCollectOptions ? data.isCollectOptions : false;
    this.materialData = data.materialData;

    if (!this.isPh) {
      if (this.printingService === 'plotter') {
        this.printServicePapers = this.realBranch.plotter.printers[0].inputBins;
        this.inputBins = this.realBranch.plotter?.printers[0].inputBins
      } else if (this.printingService === 'express') {
        this.printServicePapers = this.realBranch.express.consumables.papers;
      }
    } else {
      this.printServicePapers = this.realBranch.types;
    }

    if (this.materialData && this.materialData.availableMaterials) {
      this.availableMaterials = this.materialData.availableMaterials;
    }
  }

  async ngOnInit() {
    this.isLoading = true;
    this.selectedCollectOption = this.property;
    this.productName = this.realBranch.name ? this.realBranch.name : '';
    if (this.materialData && this.materialData.productName) {
      this.productName = this.materialData.productName;
    }
    this.product = this.realBranch;

    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.isLoading = false;
  }

  closePropertyExplainDialog() {
    this.dialogService.onCloseExplainPropertyDialog();
  }

  openPreviewDialog() {
    this.closePropertyExplainDialog();
    this.dataSharingService.triggerPreviewDialog();
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  updateCollectOptions() {
    this.dialogService.emitExplainPropertyResult(this.property);
    this.dialogRef.close(this.property);
  }

  //  collect times ==============
  getDayName(
    base: number,
    isAfter: boolean,
    isMakeUntil: boolean,
    isSkipWeekend: boolean
  ): string {
    let add = base;
    if (isMakeUntil) {
      add = base + this.extraDays();
    }
    if (isAfter && !this.isAfterHour()) {
      add += 1;
    }
    let dayIndex = this.getNextDay(add); // 0=ראשון, 6=שבת

    if (isSkipWeekend && (dayIndex === 5 || dayIndex === 6)) {
      dayIndex = 0; // הפוך חמישי, שישי, שבת לראשון
    }

    return this.translateService.instant(`collect.day-name.${dayIndex}`);
  }

  getDateName(
    base: number,
    isAfter: boolean,
    isMakeUntil: boolean,
    isSkipWeekend: boolean
  ): string {
    let add = base;
    if (isMakeUntil) {
      add = base + this.extraDays();
    }
    if (isAfter && !this.isAfterHour()) {
      add += 1;
    }

    // חישוב תאריך עתידי לפי add
    let today = new Date();
    let newDateObj = new Date(today);
    newDateObj.setDate(today.getDate() + add);

    // בדוק אם צריך לדלג על חמישי-שבת
    if (isSkipWeekend) {
      let dayOfWeek = newDateObj.getDay(); // 0=ראשון, 6=שבת
      if (dayOfWeek === 5 || dayOfWeek === 6) {
        // קפוץ ליום ראשון הבא
        let daysToAdd = (7 - dayOfWeek) % 7;
        newDateObj.setDate(newDateObj.getDate() + daysToAdd);
      }
    }

    const day = newDateObj.getDate();
    const month = newDateObj.getMonth() + 1; // חודשים ב-JS הם 0-11
    const year = newDateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  getNextDay(add: number): number {
    const today = new Date().getDay(); // 0=ראשון, 6=שבת
    return (today + add) % 7;
  }

  extraDays(add: number = 0): number {
    const production = this.getServiceExtraDays(this.selectedCollectOption);
    const delivery = this.product?.times?.makeUntilDays ? this.product.times.makeUntilDays : 2;
    return production + delivery + add;
  }

  extraDaysAndSkipWeekend(add: number = 0, isAfter: boolean = false): number {
    let isAfterExtraDay = (isAfter && this.isAfterHour()) ? 1 : 0;
    const extraDays = this.extraDays(add);
    const skipWeekend = this.skipWeekendDays(extraDays);
    return extraDays + skipWeekend + isAfterExtraDay;
  }

  skipWeekendDays(add: number = 0): number {
    const today = new Date();
    const futureDay = (today.getDay() + add) % 7;
    if (futureDay === 5) return 2;
    if (futureDay === 6) return 1;
    return 0;
  }

  getHour(): string {
    const makeUntilHour = this.product.times.makeUntilHour ? this.product.times.makeUntilHour : 12;
    const hour = Number(makeUntilHour);
    return `${hour.toString().padStart(2, '0')}:00`;
  }

  isAfterHour(): boolean {
    const now = new Date();
    const currentHour = now.getHours() + now.getMinutes() / 60;
    const makeUntilHour = Number(this.product.times.makeUntilHour) || 12;
    return currentHour > makeUntilHour;
  }

  getServiceExtraDays(service: string): number {
    if (service === 'points') {
      return 3;
    } else if (service === 'delivery') {
      return 3;
    }
    return 0;
  }

  isCollectServiceAvalble(op) {
    if (op === 'appointment') {
      return (this.product?.times && this.product.times?.isTestAllowed);
    } else if (op === 'pickup') {
      return (this.product?.places && this.product.places.length > 0);
    } else if (op === 'points' || op === 'delivery') {
      return (this.product?.times && this.product.times?.isDeliveriesAllowed);
    }
    return true;
  }

  isWeekendExplain(): boolean {
    // מחשב את הערך הראשון
    const first = this.isAfterHour()
      ? this.getDayName(2, true, true, true)
      : this.getDayName(1, false, true, true);

    // מחשב את הערך השני
    const second = this.isAfterHour()
      ? this.getDayName(1, true, true, true)
      : this.getDayName(0, false, true, true);

    // משווה ומחזיר תוצאה בוליאנית
    return first === second;
  }
  // // collect times ==============

  getCollectionServicePrice(service: string | null | undefined): number {
    return getPhCollectionServicePrice(service);
  }


  // ===============

  /** Same rule as material tooltip: first material with isRecommended === true. */
  isFirstRecommendedMaterial(material: any): boolean {
    const first = this.availableMaterials?.find((m: any) => m?.isRecommended === true);
    return !!first && first.name === material?.name;
  }
}
